import axios from "axios";

export const GET_ALL = "binnacles";
export const GET_ALL_BY_CASE = "binnacles/getAllByCase";
export const SAVE = "binnacles";


export let getAll = function () {
    return axios.get(GET_ALL);
}

export let getAllByCase = function (caseId) {
    return axios.get(`${GET_ALL_BY_CASE}/${caseId}`);
}

export let save = function (data, slug) {
    return axios.post(`${SAVE}?slug=${slug}`, data);
}

